<div class="container-fluid novedades-liquidacion-page px-3 px-md-4 py-2">
  <div class="spinner-container" *ngIf="!contentLoaded">
    <mat-spinner></mat-spinner>
  </div>
  <div class="row">
    <div class="col-12 col-md-6 mx-auto text-center text-white">
      <app-alert [titulo]="'Liquidaciones'"></app-alert>
    </div>
  </div>
  <div class="row liquidacion-filter-row">
    <div class="col-12 col-xl-6 ml-auto liquidacion-filter-column">
      <app-filter-card class="liquidacion-filter-card" (filterEmit)="filter($event)" [hasLegajoInput]="false" [hasExportExcelButton]="true"
        (printExcelEmit)="printFile(true)" [exportExcelButtonDisabled]="false"
        [allowOneMoreDay]="true" [useModernActions]="true" [filterButtonText]="'Buscar'"></app-filter-card>
    </div>
  </div>
  <div class="row mb-2">
    <div class="col-12">
      <mat-form-field appearance="outline" class="liquidacion-table-filter">
        <mat-label>Filtrar registros</mat-label>
        <input matInput (keyup)="applyFilter($event)">
        <mat-icon matSuffix>search</mat-icon>
      </mat-form-field>
    </div>
  </div>

  <div class="row g-0">
    <div class="col-12">
      <div class="table-container liquidacion-table-container">
        <table #matTable mat-table [dataSource]="dataSource" class="mat-elevation-z8 liquidacion-table">

          <!-- Agrupadores -->
          <ng-container *ngFor="let groupCol of groupColDef" [matColumnDef]="groupCol.colDef">
            <th mat-header-cell *matHeaderCellDef [style.text-align]="'center'" [attr.colspan]="groupCol.colSpan"
              class="bg-agrupador text-white">
              {{ groupCol.colDef }}
            </th>
          </ng-container>

          <!-- Filas subcolumnas -->
          <ng-container *ngFor="let col of columnsDef, let i = index" [matColumnDef]="col"
            [sticky]="isSticky(col, null)">
            <div *ngIf="col !== 'accion';else btnAction">
              <th class="border bg-title" mat-header-cell *matHeaderCellDef> {{ col }} </th>
              <td class="border" mat-cell *matCellDef="let element" matTooltip="{{ element[col] }}"
                [ngClass]="isSticky(col, element)">
                {{ getCellData(element[col], col) }}
              </td>
            </div>

            <ng-template #btnAction>
              <th mat-header-cell *matHeaderCellDef class="border text-white"> </th>
              <td mat-cell *matCellDef="let element; let i = index" class="text-center">
                <button mat-mini-fab class="btn-open-detalle mx-3" color="primary" matTooltip="Ver detalle"
                  (click)="openModal(element)">
                  <mat-icon>description</mat-icon>
                </button>
              </td>
            </ng-template>

          </ng-container>

          <!-- Nombres de agrupadores -->
          <tr mat-header-row *matHeaderRowDef="groupColHeaders; sticky: true"></tr>

          <!-- Nombres de columnas -->
          <tr mat-header-row *matHeaderRowDef="columnsDef; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: columnsDef;" [ngClass]="getRowClassCondition(row)"></tr>
        </table>
      </div>


      <mat-paginator #detallePaginator class="liquidacion-paginator" [pageSizeOptions]="[1000, 500]"></mat-paginator>
    </div>
  </div>
</div>
